var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择样式")
    }
  }, [_c("div", {
    staticClass: "imgList"
  }, _vm._l(_vm.configureList, function (item, index) {
    return _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon,
        alt: ""
      }
    })]);
  }), 0)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.productListModule.productNameColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.productListModule.productNameColor, "productNameColor", "productListModule");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体大小")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.productListModule.productNameFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form.productListModule, "productNameFontSize", $$v);
      },
      expression: "form.productListModule.productNameFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 18
    }
  }, [_vm._v(" 18px ")]), _c("a-select-option", {
    attrs: {
      value: 20
    }
  }, [_vm._v(" 20px ")]), _c("a-select-option", {
    attrs: {
      value: 22
    }
  }, [_vm._v(" 22px ")])], 1)], 1)])]), _vm.form.controlsComponentsMark == "productList1" ? [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品按钮设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("边框颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.productListModule.productButtonBorderColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.productListModule.productButtonBorderColor, "productButtonBorderColor", "productListModule");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("背景颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.productListModule.productButtonBgColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.productListModule.productButtonBgColor, "productButtonBgColor", "productListModule");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)])])] : _vm._e(), _vm.form.controlsComponentsMark == "productList2" ? [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他字段设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.productListModule.otherFieldsColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.productListModule.otherFieldsColor, "otherFieldsColor", "productListModule");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体增大")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.productListModule.otherFieldsFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form.productListModule, "otherFieldsFontSize", $$v);
      },
      expression: "form.productListModule.otherFieldsFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 12
    }
  }, [_vm._v(" 12px ")]), _c("a-select-option", {
    attrs: {
      value: 14
    }
  }, [_vm._v(" 14px ")]), _c("a-select-option", {
    attrs: {
      value: 16
    }
  }, [_vm._v(" 16px ")])], 1)], 1)])])] : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("落地页配置")
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.landingPageModuleDisplay
    },
    on: {
      change: _vm.onChangeLandingPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("展示落地页")) + " ")])], 1), _vm.form.landingPageModuleDisplay ? [_c("a-form-model-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("页面背景图")
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "dynamicControls"
      },
      "before-upload": _vm.beforeUpload
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.form.landingPageModule.backgroundImage ? _c("img", {
    staticStyle: {
      width: "100px",
      height: "100px"
    },
    attrs: {
      src: _vm.form.landingPageModule.backgroundImage,
      alt: "file"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)])], 1), _vm._l(_vm.form.landingPageModule.buttonInfo, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      staticClass: "btnBox",
      attrs: {
        label: _vm.$t("按钮设置") + (index + 1)
      }
    }, [index != 0 ? _c("a-icon", {
      staticClass: "icon",
      attrs: {
        type: "delete"
      },
      on: {
        click: function ($event) {
          return _vm.delBtnFun(index);
        }
      }
    }) : _vm._e(), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + item.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(item.buttonFontColor, "buttonFontColor", "landingPageModule", index);
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + item.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(item.buttonBgColor, "buttonBgColor", "landingPageModule", index);
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("a-input", {
      attrs: {
        maxLength: 15,
        placeholder: _vm.$t("请输入") + "2-15" + _vm.$t("字符")
      },
      on: {
        blur: function ($event) {
          return _vm.handleBlurTrim(index, $event);
        }
      },
      model: {
        value: item.buttonName,
        callback: function ($$v) {
          _vm.$set(item, "buttonName", $$v);
        },
        expression: "item.buttonName"
      }
    })], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮跳转模版")))]), _c("div", {
      staticClass: "contBox"
    }, [index != 0 ? [_c("a-select", {
      staticStyle: {
        width: "180px"
      },
      attrs: {
        placeholder: _vm.$t("请选择跳转的二维码模版"),
        "show-search": "",
        "option-filter-prop": "label"
      },
      on: {
        select: function ($event) {
          return _vm.buttonJumpEventChange(index, $event);
        }
      },
      model: {
        value: item.buttonJumpEvent,
        callback: function ($$v) {
          _vm.$set(item, "buttonJumpEvent", $$v);
        },
        expression: "item.buttonJumpEvent"
      }
    }, _vm._l(_vm.templateList, function (item) {
      return _c("a-select-option", {
        key: item.id,
        attrs: {
          value: item.id,
          label: item.customerInsuranceName + item.name
        }
      }, [_c("a-tooltip", {
        staticStyle: {
          width: "300px"
        },
        attrs: {
          placement: "top",
          title: item.customerInsuranceName + "-" + item.name
        }
      }, [_vm._v(" " + _vm._s(item.customerInsuranceName) + " - " + _vm._s(item.name) + " ")])], 1);
    }), 1)] : _c("a-input", {
      attrs: {
        disabled: true,
        value: _vm.$t("产品列表页")
      }
    })], 2)])], 1);
  }), _vm.form.landingPageModule.buttonInfo && _vm.form.landingPageModule.buttonInfo.length != 2 ? _c("a-button", {
    staticClass: "size",
    staticStyle: {
      padding: "0 10px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addBtnFun
    }
  }, [_vm._v(_vm._s(_vm.$t("增加页面按钮")))]) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面展示")
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.changePageShow
    },
    model: {
      value: _vm.pageModuleShow,
      callback: function ($$v) {
        _vm.pageModuleShow = $$v;
      },
      expression: "pageModuleShow"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("落地页")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("列表页")))])], 1)], 1)] : _vm._e()], 2), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };